export default "__VITE_ASSET__CB3gn8b4__ 500w";